import { useRef, useState, useEffect } from 'react'
import * as S from './styles'
import IconClose from '../../../assets/icons/icon-close.svg'
import NewCard from '../NewCard'

import FormAddNewCreditCard from '../FormAddNewCreditCard'
import { useDispatch, useSelector } from 'react-redux'
import CreditCard from '../CreditCard'
import pagamento from '../../../api/pagamento'
import FormCVV from '../FormCVV'
import { useToast } from '../../../hooks/toast'
import { converterNegociacaoCartao } from '../../../pages/Negociacoes/fetch'
import { useHistory } from 'react-router-dom'
import ProdutosEsgotadosMessage from '../ProdutosEsgotadosMessage'
import { sendToConverterCheckout } from '../../../utils/rotaConverter'
import { useQueryClient } from 'react-query'
import Loader from '../../Loader'

const PaymentCardsModal = ({
  showModal,
  setShowModal,
  cardData,
  formas,
  setUserCards,
  pedido,
  isLoading,
  setPedido,
  type
}) => {
  const modalRef = useRef()
  const { addToast } = useToast()
  const queryClient = useQueryClient()

  const dispatch = useDispatch()

  const [paymentModal, setPaymentModal] = useState(0)
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('')
  const [pedidoNumero, setPedidoNumero] = useState('')
  const [esgotadoMessage, setEsgotadoMessage] = useState()
  const [loader, setLoader] = useState(false)

  // const [selectedParcela, setSelectedParcela] = useState('')
  // const [selectedCondicoes, setSelectedCondicoes] = useState('')

  // const [current, setCurrent] = useState(0)

  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setShowModal(false)
    }
  }

  async function getSavedCards() {
    // setLoader(true)
    await pagamento
      .getCartoes()
      .then((response) => {
        // setLoader(false)
        return response.json()
      })
      .then((obj) => setUserCards(obj))
      .catch((err) => {
        // if (err) setLoader(false)
      })
  }

  const handleSubmit = async () => {
    setLoader(true)

    if (selectedPaymentMethod !== '') {
      try {
        // console.log('POST API Cotações/Negociações')
        // console.log(selectedPaymentMethod)
        // console.log(pedido)
        // console.log('select', selectedPaymentMethod)

        let res = await converterNegociacaoCartao(
          pedido,
          selectedPaymentMethod,
          type,
          selectedPaymentMethod.Brand
        )
        // console.log(res)
        queryClient.refetchQueries('cotacao')
        queryClient.refetchQueries('negociacao')

        try {
          if (res?.includes('Convertido')) {
            // history.push('/finalizado', {
            //   idPedido: res,
            //   type: 'cartao',
            //   valorST: pedido.ValorSubstituicaoTributaria,
            //   operacao: type
            // })

            setLoader(false)

            sendToConverterCheckout(
              res,
              'cartao',
              pedido.ValorSubstituicaoTributaria,
              type
            )
          } else if (res?.includes('esgotou')) {
            // addToast({
            //   type: 'info',
            //   title:
            //     'Problema ao gerar Pedido. Será necessário fazer uma nova(cotação ou negociação).',
            //   description: `${res}`,
            //   timer: 20000
            // })
            setEsgotadoMessage(res)
            setPaymentModal(2)
            setLoader(false)
          } else {
            addToast({
              type: 'error',
              title: 'Problema ao gerar Pedido. Tente novamente',
              description: `${res}`
            })
            setLoader(false)
          }
        } catch (error) {
          addToast({
            type: 'error',
            title: 'Problema ao gerar Pedido. Tente novamente',
            description: `${res.Message}`
          })
          setLoader(false)
        }

        // setPedidoNumero(res)
      } catch (error) {
        addToast({
          type: 'error',
          title: 'Problema ao gerar Pedido. Tente novamente',
          description: `${error}`
        })
        setLoader(false)
      }
    } else {
      addToast({
        type: 'error',
        title: 'Selecione uma forma de pagamento'
      })
      setLoader(false)
    }
  }

  useEffect(() => {
    getSavedCards()
  }, [paymentModal])

  return (
    <>
      {!!loader && <Loader />}
      {showModal ? (
        <S.Background onClick={closeModal}>
          <S.ModalWrapper>
            {/* <FormAddNewCreditCard
              setShowModal={setShowModal}
              cancelar={() => setShowModal((prev) => !prev)}
            /> */}

            {paymentModal === 0 || paymentModal === 3 ? (
              <>
                <S.ContentWrapper>
                  <h3>Forma de Pagamento</h3>
                  <div className="content">
                    {cardData.map((card) => {
                      return (
                        <S.CardWrapper key={card.IdCartao}>
                          <CreditCard
                            data={card}
                            type="modal"
                            check={selectedPaymentMethod}
                            setCheck={setSelectedPaymentMethod}
                            current={paymentModal}
                            setCurrent={setPaymentModal}
                            setLoader={setLoader}
                          ></CreditCard>
                        </S.CardWrapper>
                      )
                    })}
                    <S.CardWrapper>
                      <NewCard
                        setPaymentModal={setPaymentModal}
                        type="modal"
                      ></NewCard>
                    </S.CardWrapper>
                  </div>

                  <S.ProfileBoxFooter>
                    <S.Button
                      type="submit"
                      onClick={() => {
                        handleSubmit()
                        // setShowModal((prev) => !prev)
                        // setPaymentModal(2)
                      }}
                    >
                      Finalizar Compra
                    </S.Button>
                  </S.ProfileBoxFooter>
                </S.ContentWrapper>
                <S.HeaderModalClose
                  className="header-modal-close"
                  aria-label="Close modal"
                  onClick={() => {
                    setShowModal((prev) => !prev)
                    setPaymentModal(0)
                  }}
                >
                  {/* <Icon name="icon-close" /> */}
                  <img src={IconClose} alt="" />
                </S.HeaderModalClose>
              </>
            ) : null}

            {paymentModal === 1 && (
              <>
                <S.ContentWrapper>
                  <FormAddNewCreditCard
                    setPaymentModal={setPaymentModal}
                    type="insideModal"
                    tipo={type}
                    current={paymentModal}
                    setCurrent={setPaymentModal}
                    pedido={pedido}
                    cotacaoNegociacao
                    setLoader={setLoader}
                    setEsgotadoMessage={setEsgotadoMessage}
                  ></FormAddNewCreditCard>
                </S.ContentWrapper>

                <S.HeaderModalClose
                  className="header-modal-close"
                  aria-label="Close modal"
                  onClick={() => {
                    setShowModal((prev) => !prev)
                    setPaymentModal(0)
                  }}
                >
                  {/* <Icon name="icon-close" /> */}
                  <img src={IconClose} alt="" />
                </S.HeaderModalClose>
              </>
            )}

            {paymentModal === 2 && (
              <>
                <S.ContentWrapper>
                  <ProdutosEsgotadosMessage
                    message={esgotadoMessage}
                  ></ProdutosEsgotadosMessage>
                </S.ContentWrapper>

                <S.HeaderModalClose
                  className="header-modal-close"
                  aria-label="Close modal"
                  onClick={() => {
                    setShowModal((prev) => !prev)
                    setPaymentModal(0)
                  }}
                >
                  {/* <Icon name="icon-close" /> */}
                  <img src={IconClose} alt="" />
                </S.HeaderModalClose>
              </>
            )}
          </S.ModalWrapper>
        </S.Background>
      ) : null}
    </>
  )
}

export default PaymentCardsModal
